<template>
  <div class="body">
    <header>
      <div class="title">
        <div class="title_left" style="display: flex;align-items: center">
          <img src="../../model/Images/logo.png" style="width: 40px;height: 40px;margin-right: 10px" alt="">
          瀚洋电信统一管理平台
        </div>
        <div class="title_right">
          <div @click="(()=>this.$router.back())">返回</div>
        </div>
      </div>
    </header>
    <div class="main">
      <el-tabs style="min-height: 100vh!important" type="border-card">
        <el-tab-pane style="font-size: 16px!important" :label="title">
          <div style="width: 100%;padding: 0 30px;box-sizing: border-box">
            <div class="main_title">
              <h3>标题： 这是公告详情页面标题</h3>
              <div style="text-align: right;font-size: 14px">2022-05-31</div>
            </div>
            <el-card style="margin-top: 20px;padding: 10px;box-sizing: border-box" class="box-card">
              <img style="width: 100%;height: 300px;border-radius: 6px" src="../../assets/bg01.jpg" alt="">
              <div style="text-indent: 2em;line-height: 35px;margin-top: 20px">
                这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容这是公告内容
              </div>
            </el-card>
            <div style="text-align: right;font-size: 14px;margin-top: 20px">
              发布人：瀚洋电信
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'announcement',
  components: {
  },
  data () {
    return {
      title: ''
    }
  },
  created () {
    const title = this.$route.query
    if (title) {
      switch (title) {
        case '1':
          this.title = '公司公告'
          break
        case '2':
          this.title = '上海公告'
          break
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .body {

    header {
      width: 100%;
      height: 10vh;
      line-height: 10vh;
      background-color: #0a4b9d;

      .title {
        width: 80%;
        margin: 0 auto;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;

        .title_left {
          font-size: 30px;
          font-weight: 700;
          color: #fff;
        }

        .title_right {
          display: flex;
          justify-content: space-between;
          align-items: center;

          div {
            font-size: 13px;
            color: #fff;
            margin-left: 20px;
          }
        }
      }
    }
    .main {
      width: 80%;
      margin: 0 auto;
      .main_title{
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
        align-items: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/AnnouncementDetail.vue